<template>
    <div class="widget-inner storage-widget" style="margin:10px;">
        <div v-if="0 !== widgetContent.max && (calculatedStorage.percent >= 100)" class="storage-full">Speicherplatz voll!</div>
        <div v-else-if="0 !== widgetContent.max && (calculatedStorage.percent > 80 && calculatedStorage.percent < 100)" class="storage-warning">Speicherplatz knapp!</div>
        <div id="storage" class="clearfix">
            <div class="storage-part storage-file-bg" id="storage-file" :style="{width: calculatedStorage.file + '%'}"></div>
            <div class="storage-part storage-image-bg" id="storage-image" :style="{width: calculatedStorage.image + '%', left: calculatedStorage.file + '%'}"></div>
            <div class="storage-part storage-database-bg" id="storage-database"
                :style="{width: calculatedStorage.database + '%', left: (calculatedStorage.image + calculatedStorage.file) + '%'}"></div>
            <div class="storage-part storage-backup-bg" id="storage-backup"
                :style="{width: calculatedStorage.backup + '%', left: (calculatedStorage.image + calculatedStorage.file + calculatedStorage.database) + '%'}"></div>
            <div id="storage-used">
                <span v-if="reloading || widgetContent.max === 0">Speicherbelegung wird geladen ...</span>
                <span v-else-if="0 !== widgetContent.max">{{calculatedStorage.percent}}% von {{fileSize(widgetContent.max)}} belegt</span>
            </div>
        </div>
        <div id="storage-text">
            <div v-if="isWidget" class="clearfix">
                <span id="storage-refresh" v-interact="refresh"><i class="material-icons" aria-hidden="true" role="img">refresh</i> Erneuern</span>
                <span id="storage-calculated" v-if="0 !== widgetContent.max">Stand: <span v-if="widgetContent.calculated">{{datetime(widgetContent.calculated)}}</span></span>
            </div>
            <template v-else>
                <span id="storage-refresh" v-interact="refresh">
                    <i class="material-icons" aria-hidden="true" role="img">refresh</i>
                    Erneuern
                </span>
                |
            </template>

            <component v-for="type in [{eng: 'file', ger: 'Dateien'}, {eng: 'image', ger: 'Bilder'}, {eng: 'database', ger: 'Datenbank'}, {eng: 'backup', ger: 'Backups'}]" :is="isWidget ? 'div' : 'span'">
                &nbsp;<span class="storage-legend" :class="'storage-' + type.eng + '-bg'"></span> {{type.ger}}: {{fileSize(widgetContent[type.eng])}}
            </component>

            <span id="storage-calculated" v-if="!isWidget && 0 !== widgetContent.max">Stand: <span v-if="widgetContent.calculated">{{datetime(widgetContent.calculated)}}</span></span>
        </div>
        <template v-if="isWidget">
            <hr class="small">
            <router-link :to="'/settings/control/backup'">Zur &Uuml;bersicht</router-link>
        </template>

        <div v-if="!isWidget" class="request-storage-wrapper">
            <button class="button button-primary request-storage-button" @click="() => {$emit('request-storage');}">
                Mehr Speicherplatz beantragen
            </button>
        </div>
    </div>

</template>

<script lang="ts">
    import datetime from '../../filters/datetime';
    import fileSize from '../../filters/fileSize';
    import {Component, Prop} from 'vue-facing-decorator';
    import {WidgetDefault} from './WidgetDefault.vue';

    @Component({
        name: 'WidgetStorage',
        methods: {
            datetime,
            fileSize,
        }
    })
    export default class WidgetStorage extends WidgetDefault
    {
        @Prop({
            type: Boolean,
            default: true,
            required: false,
        }) isWidget: boolean;

        storageContent = null;

        reloading = false;

        get widgetContent()
        {
            return this.storageContent || this.content;
        }

        get calculatedStorage()
        {
            let used          = this.widgetContent.file + this.widgetContent.image + this.widgetContent.database + this.widgetContent.backup;
            let calculateBase = Math.max(this.widgetContent.max, used);
            let file          = (this.widgetContent.file / calculateBase) * 100;
            let image         = (this.widgetContent.image / calculateBase) * 100;
            let database      = (this.widgetContent.database / calculateBase) * 100;
            let backup        = (this.widgetContent.backup / calculateBase) * 100;

            return {
                file,
                image,
                database,
                backup,
                used,
                percent: Math.floor((used / this.widgetContent.max) * 100),
            };
        }

        refresh()
        {
            if (this.reloading)
            {
                return;
            }

            this.reloading = true;
            this.axios.get('/settings/backup/refresh-storage').then(({data: data}) =>
            {
                this.storageContent = data.data.storage;
            }).finally(() =>
            {
                this.reloading = false;
            });
        }
    };
</script>